import type { CSSInterpolation } from "@emotion/serialize";

import { serializeStyles } from "@emotion/serialize";

export function serializeCookieStyles(styles: CSSInterpolation) {
  return serializeStyles([styles]).styles;
}
